import { defineStore } from "pinia";

import API from "../api/index.js";


export const useSessionsStore = defineStore('sessions', {
   state: () => ({
     sessions: [], // each session object already has a nested `terms: []` array
   }),
 
   getters: {
     currentSession: (state) => state.sessions.find(s => s.is_current),
     currentTerm: (state) => {
       const current = state.sessions.find(s => s.is_current)
       return current?.terms.find(t => t.is_current) || null
     },
   },
 
   actions: {
     
      async fetch_sessions() {
       
      const res = await API.get_sessions_with_terms()

      this.sessions = res.data
     
      },
   
   },
 
})